import {Component, Input, OnInit} from '@angular/core';
import {AbstractControl, FormControl} from "@angular/forms";
import {SelectOption} from "../../model/select-option.model";

@Component({
  selector: 'app-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss'],
})
export class SelectComponent  implements OnInit {

  @Input() label: string;
  @Input() control: FormControl;
  @Input() options: SelectOption[];

  constructor() { }

  ngOnInit() {}

}
